import React from 'react';
import { Route, Routes } from 'react-router-dom-latest';
import { GruntworxLandingView } from './views';

export const GruntworxIntegrationConfig = () => (
  <Routes>
    <Route path="/" element={<GruntworxLandingView />} />
  </Routes>
); 